import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	tooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	tooltip: {
		id: 'native-issue-table.common.error-cell.tooltip',
		defaultMessage: 'We couldn’t load this field’s details. Refresh and try again.',
		description: 'Tooltip shown when a field could not be shown in the table for an unknown reason',
	},
});
export default messages;
